'use client';

import type { ReactNode, ReactElement } from 'react';
import { chain, projectId, wagmiAdapter } from '@/lib/constants/config';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { WagmiProvider } from 'wagmi';
import { createAppKit } from '@reown/appkit/react';

const queryClient = new QueryClient();

const metadata = {
  name: 'PeacockAI',
  description: 'Decentralized confidential AI marketplace.',
  url: 'https://peacockmarketplace.online',
  icons: ['https://peacockmarketplace.online/logo.png'],
};

createAppKit({
  projectId,
  metadata,
  features: { smartSessions: false },
  adapters: [wagmiAdapter],
  networks: [chain],
  defaultNetwork: chain,
  defaultAccountTypes: { eip155: 'eoa' },
});

export default function BlockchainProvider({
  children,
}: {
  readonly children: ReactNode;
}): ReactElement {
  return (
    <WagmiProvider config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </WagmiProvider>
  );
}
